import { gql } from "gql";

export const GET_MCP_CONNECTION = gql(/* GraphQL */ `
  query GetMcpConnection {
    getMcpConnection {
      ...McpConnection
    }
  }
`);
